<template>
  <div class="py-16">
    <div class="flex items-center mb-10">
      <Avatar :name="initialsName" :alt="`avatar-${fullName}`" :size="48" />
      <div class="ml-16 flex flex-column">
        <span class="fs-18 fw-600 lh-28">
          {{ fullName }}
        </span>
        <span class="fw-400 fs-14 lh-20 gray-700">
          {{ `${formatDate(review.date, 'm d Y')}` }}
        </span>
      </div>
    </div>
    <div class="flex items-center flex-wrap">
      <div class="flex items-center">
        <Rate v-if="review.rating" :rate="review.rating" />
      </div>
      <template v-if="showSubTitle">
        <span v-if="isDesktop" class="px-6 pb-4">·</span>
        <span class="text-sm-rg gray-700">
          {{ `Given for: ${review.trip_name} to ${review.country_name} in ${day} for ${traveller}, operated by ${fullNameDesigner}.` }}
        </span>
      </template>
    </div>
    <div class="item-review__content text-md-rg mt-4" v-if="review.content">
      <Readmore :text="reviewContent" :text-max="50" heap="view-full-review-content" />
      <div v-if="images.length" class="flex grid-gap-12 mt-10">
        <BaseResponsiveImages v-for="(item, index) in images" :key="index" customClass="h-120 w-120 br-12 mb-h-60 mb-w-60" :src="item" :alt="item.caption || undefined" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Avatar from '~/components/ui/avatar/Avatar.vue'
import BaseResponsiveImages from '~/components/ui/BaseResponsiveImages/BaseResponsiveImages.vue'
import Rate from '~/components/ui/rate/Rate.vue'
import Readmore from '~/components/ui/readmore/readmoreHTML.vue'
import { formatDate } from '~/helper/index.js'

const props = defineProps({
  review: {
    type: Object,
    default: null,
  },
})
const { isDesktop } = useDevice()
const fullName = computed(() => `${props.review.first_name} ${props.review.last_name}`)
const fullNameDesigner = computed(() => `${props.review.designer_fname} ${props.review.designer_lname}`)
const images = computed(() => props.review?.images_comment || [])
const day = computed(() => {
  if (!props.review) return ''
  const count = props.review.number_of_days
  return count ? (count === 1 ? `${count} day` : `${count} days`) : ''
})
const traveller = computed(() => {
  if (!props.review) return ''
  const count = props.review.number_of_travellers
  return count ? (count === 1 ? `${count} traveller` : `${count} travellers`) : ''
})
const initialsName = computed(() => `${props.review.first_name ? props.review.first_name[0] : ''} ${props.review.last_name ? props.review.last_name[0] : ''}`)
const showSubTitle = computed(() => traveller.value && day.value && props.review.trip_name && props.review.country_name && fullNameDesigner.value)
const reviewContent = computed(() => {
  if (!props.review) return ''
  const regex = /(\<br[\s]*\/?\>[\s]*)+/g
  const content = props.review.content ? props.review.content.replace(regex, '<br/>') : ''
  return content
})
</script>

<style lang="scss" scoped>
.item-review {
  &__content {
    & :deep(.readmore--html) {
      button {
        .underline {
          font-weight: 700;
        }
      }
    }
  }
}
</style>
